"use strict";
// Class definition
import Swiper from "swiper";
import {Autoplay, Grid, Navigation, Pagination, Thumbs} from "swiper/modules"
import Swal from 'sweetalert2'
import 'animate.css';
import SwiperAnimation from '@cycjimmy/swiper-animation';
import {Modal, Popover, Tab,} from 'bootstrap';
import SVGInject from '@iconfu/svg-inject';

import {Fancybox} from "@fancyapps/ui";
import {CountUp} from "countup.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import {isScrolledIntoView} from "./General";
import YouTubePlayer from "yt-player";

var App = function () {
    let swiperAnimation;
    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Grid]);
        swiperAnimation = new SwiperAnimation();
    }
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }


    const MainSlider = () => {
        var interleaveOffset = 0.5;

        let videos = document.querySelectorAll('.home-slider .swiper-slide video');
        videos.forEach(function ($el) {
            let ths = $el;
            let load = setInterval(function () {
                if (ths.readyState >= 1) {
                    let duration = (ths.duration * 1000) - 1000
                    if (duration > 0) {
                        ths.closest(".swiper-slide").setAttribute('data-swiper-autoplay', duration);
                    }
                    clearInterval(load);
                }
            }, 100)
        });


        let youtubeVideos = document.querySelectorAll('.home-slider .video-wrapper .youtube-video');
        let home_slider;

        setTimeout(function () {
            home_slider = new Swiper('.home-slider', {
                loop: false,
                speed: 1000,
                grabCursor: true,
                mousewheelControl: true,
                keyboardControl: true,
                init: (youtubeVideos.length <= 0),
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false
                },
                navigation: {
                    nextEl: '.slider-controls .next',
                    prevEl: '.slider-controls .prev',
                },

                on: {
                    touchStart: function () {
                        var swiper = this;
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = "";
                        }
                    },
                    setTransition: function (swiper, speed) {
                        for (var i = 0; i < swiper.slides.length; i++) {
                            swiper.slides[i].style.transition = speed + "ms";
                            if (swiper.slides[i].querySelector(".slide-background"))
                                swiper.slides[i].querySelector(".slide-background").style.transition =
                                    speed + "ms";
                        }
                    },
                    init: function (swiper) {
                        swiperAnimation.init(this).animate();
                        updateCounter(swiper);
                        var currentVideo = $(swiper.slides[this.activeIndex]).find("video");
                        currentVideo.trigger('play');


                    },
                    slideChange: function (swiper) {
                        swiperAnimation.init(this).animate();
                        updateCounter(swiper);
                        videos.forEach(function (ths) {
                            ths.currentTime = 0;
                        });
                        var prevVideo = $(swiper.slides[this.previousIndex]).find("video");
                        var currentVideo = $(swiper.slides[this.activeIndex]).find("video");
                        prevVideo.trigger('stop');
                        currentVideo.trigger('play');


                    }
                }
            });
        }, 500);

        if (youtubeVideos) {
            youtubeVideos.forEach((youtubeVideo) => {
                const player = new YouTubePlayer(youtubeVideo, {
                    related: false,
                    fullscreen: true,
                    keyboard: false,
                    modestBranding: true,
                    controls: false,
                    annotations: false,
                });
                player.mute();
                player.load(youtubeVideo.dataset.videoId, ["autoplay"]);

                let swiperSlide = youtubeVideo.parentElement.parentElement.parentElement;
                let firstPlaying = true;
                player.on('playing', async () => {
                    let duration = await player.getDuration() * 1000;
                    if (duration > 0) {
                        await swiperSlide.setAttribute('data-swiper-autoplay', duration);

                        setTimeout(() => {
                            home_slider.init();
                        }, 700)

                        if (firstPlaying) {
                            player.stop();
                            firstPlaying = false;
                            player.play();
                        }

                        setTimeout(() => {
                            home_slider.on('slideChange', function () {
                                // find the current slide
                                let currentSlide = home_slider.slides[home_slider.activeIndex];
                                let prevSlide = home_slider.slides[home_slider.previousIndex];

                                if (prevSlide.querySelector('.youtube-video')) {
                                    player.pause();
                                }
                            })
                        }, 700)
                    }
                })
            })
        }

        function updateCounter(swiper) {
            let index = swiper.activeIndex + 1;
            if (index < 10) index = "0" + index;
            document.querySelector('.slider-controls .counter').textContent = index;
        }

    }

    const otherSlide = () => {

        var swiper3 = new Swiper(".home-services", {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            }
        });

        var swiper4 = new Swiper(".home-other-services", {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }

        });
        var swiper5 = new Swiper(".home-blogs", {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }
        });
    }

    const Count = () => {

        const runCountUp = () => {
            document.querySelectorAll(".count").forEach((el) => {
                const end = parseFloat(el.dataset.end);

                const counter = new CountUp(el, end, {
                    duration: 2,
                });

                if (!counter.error) {
                    counter.start();
                } else {
                    console.error(counter.error);
                }
            });
        };

        // ---------------------------
        // 1) Scroll ile içeri girince başlat
        // ---------------------------
        const isScrolledIntoView = (el) => {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };

        const firstCountEl = document.querySelector(".count");
        let scrollStarted = false;

        if (firstCountEl) {
            const onScroll = () => {
                if (!scrollStarted && isScrolledIntoView(firstCountEl)) {
                    runCountUp();
                    scrollStarted = true;
                    window.removeEventListener("scroll", onScroll);
                }
            };

            window.addEventListener("scroll", onScroll);
        }

        // ---------------------------
        // 2) .has-count-up active olunca başlat (Opsiyonel)
        // ---------------------------
        const target = document.querySelector(".has-count-up");

        if (target) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        if (target.classList.contains("active")) {
                            runCountUp();
                        }
                    }
                });
            });

            observer.observe(target, {attributes: true});
        }
    };

    const goTop = () => {
        const goTop = document.getElementById('goTop');
        const circle = goTop.querySelector('.progress-ring__circle');
        const radius = 18;
        const circumference = 2 * Math.PI * radius;

        circle.style.strokeDasharray = circumference;
        circle.style.strokeDashoffset = circumference;

        window.addEventListener('scroll', () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = scrollTop / docHeight;

            circle.style.strokeDashoffset =
                circumference - progress * circumference;
        });

        goTop.addEventListener('click', () => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }


    return {
        init: function () {
            Fancybox.bind('[data-fancybox]')
            swiperUse();
            MainSlider();
            otherSlide();
            Count();
            goTop();
            // intTelInput();

        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    App.init();
});


